import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import API_URL from '../api';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [settings, setSettings] = useState({ company_name: 'JobCostNow', logo_url: '' });
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`)
      .then(res => {
        if (res.data) setSettings({ company_name: res.data.company_name || 'JobCostNow', logo_url: res.data.logo_url || '' });
      })
      .catch(() => {});
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const nav = [
    { label: 'Dashboard', path: '/' },
    { label: 'Customers', path: '/customers' },
    { label: 'Reports', path: '/reports' },
    { label: 'Settings', path: '/settings' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div style={styles.shell}>
      <div style={styles.sidebar}>
        <div>
          <div style={styles.brand}>
            {settings.logo_url
              ? <img src={settings.logo_url} alt={settings.company_name} style={styles.logo} onError={e => { e.target.style.display='none'; }} />
              : null}
            <div style={styles.brandName}>{settings.company_name}</div>
          </div>
          <nav style={styles.nav}>
            {nav.map(item => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                style={{...styles.navItem, ...(isActive(item.path) ? styles.navItemActive : {})}}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>

        <div style={styles.userBox}>
          <div style={styles.userName}>{user.name || user.email || 'User'}</div>
          <button onClick={logout} style={styles.logout}>Log out</button>
          <div style={styles.poweredBy}>Powered by JobCostNow</div>
        </div>
      </div>

      <div style={styles.main}>
        {children}
      </div>
    </div>
  );
}

const styles = {
  shell: { display: 'flex', minHeight: '100vh', background: '#f4f6f9', fontFamily: 'Arial, sans-serif' },
  sidebar: { width: '230px', background: '#2E4057', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '24px 0', position: 'sticky', top: 0, height: '100vh', boxSizing: 'border-box', flexShrink: 0 },
  brand: { padding: '0 24px 24px', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: '16px', textAlign: 'center' },
  logo: { maxHeight: '44px', maxWidth: '160px', objectFit: 'contain', marginBottom: '10px', display: 'block', marginLeft: 'auto', marginRight: 'auto' },
  brandName: { color: '#fff', fontSize: '16px', fontWeight: 'bold' },
  nav: { display: 'flex', flexDirection: 'column', gap: '4px', padding: '0 12px' },
  navItem: { textAlign: 'left', padding: '11px 16px', background: 'transparent', color: '#cdd6e0', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' },
  navItemActive: { background: 'rgba(255,255,255,0.12)', color: '#fff', fontWeight: 'bold' },
  userBox: { padding: '16px 24px 0', borderTop: '1px solid rgba(255,255,255,0.1)', margin: '0 0px' },
  userName: { color: '#fff', fontSize: '13px', fontWeight: 'bold', marginBottom: '8px' },
  logout: { width: '100%', padding: '8px', background: 'transparent', color: '#cdd6e0', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  poweredBy: { color: 'rgba(255,255,255,0.4)', fontSize: '11px', marginTop: '14px', textAlign: 'center' },
  main: { flex: 1, minWidth: 0 },
};
